import { locale } from "../locale"
import { state } from "../state"
import { binarySearchInsert, binarySearchRemove } from "../utils"
import { Bulma } from "../view/bulma"
import { MaterialDesign } from "../view/material_design"

/**
 * DEPRECATED
 * @param {Subscription} sub 
 * @param {import("../api/prices").Price[]} prices 
 * @param {"EUR"|"SEK"} currency
 * @param {boolean} isOwner
 */
function subscriptionField(sub, prices, currency, isOwner) {
    const subSelect = Bulma.select({
        disabled: !isOwner,
        onInput: onSelectSubscription,
        options: [
            Bulma.option("None", "", sub.PriceIds.Next === ""),
            ...prices.map(p => Bulma.option(p.Name, p.Id, sub.PriceIds.Next === p.Id)),
        ],
    })

    const priceInfo = Bulma.input({
        type: "text",
        isReadonly: true,
        styles: ['is-static'],
    })

    function onSelectSubscription() {
        const priceId = subSelect.getValue()
        if (priceId === "") priceInfo.setValue(locale.string({
            enGB: `0 ${currency} per month`,
            deDE: `0 ${currency} pro Monat`,
            frFR: `0 ${currency} par mois`,
            svSE: `0 ${currency} per månad`,
        }))
        else prices.find(price => price.Id === priceId)?.toString()
            .then(s => priceInfo.setValue(s))
    }

    onSelectSubscription()
    const element = Bulma.field({},
        Bulma.label(locale.strings.subscription),
        Bulma.control({},
            subSelect.element,
        ),
        Bulma.control({},
            priceInfo.element,
        ),
    )

    return {
        element,
        getPriceId: () => subSelect.getValue(),
        setPriceId: subSelect.setValue.bind(subSelect.element),
    }
}

/**
 * DEPRECATED
 * @param {DeviceMetadata} meta
 */
function sharingField(meta) {
    // Create local copy to avoid changes to be reflected on devices page before
    // next auto-refresh
    const access = Array.from(meta.Access)
    const notify = Array.from(meta.Notify || [])

    /** @type {(email: string) => HTMLTableRowElement} */
    const newRow = email => {
        const notificationsOnIcon = MaterialDesign.icon({
            id: "notifications",
            onClick: () => {
                binarySearchRemove(notify, email)
                notificationsOnIcon.replaceWith(notificationsOffIcon)
            },
        })

        const notificationsOffIcon = MaterialDesign.icon({
            id: "notifications_off",
            onClick: () => {
                binarySearchInsert(notify, email)
                notificationsOffIcon.replaceWith(notificationsOnIcon)
            },
        })

        const ownerIcon = MaterialDesign.icon({
            id: "star",
        })

        const removeUserIcon = MaterialDesign.icon({
            id: "close",
            onClick: () => {
                binarySearchRemove(access, email)
                binarySearchRemove(notify, email)
                row.remove()
            }
        })

        const row = Bulma.tableRow({},
            Bulma.tableDataCell(
                email,
            ),
            Bulma.tableDataCell(
                notify.includes(email) ? notificationsOnIcon : notificationsOffIcon,
            ),
            Bulma.tableDataCell(
                email === meta.OwnerEmail ? ownerIcon : removeUserIcon,
            ),
        )

        return row
    }

    const emailInput = Bulma.input({
        type: "text",
        placeholder: locale.strings.email,
    })

    const onClickInvite = () => {
        const email = emailInput.getValue().trim().toLowerCase()
        emailInput.setValue("")
        if (access.includes(email)) return

        binarySearchInsert(access, email)
        userTable.tBodies[0].insertRow(access.indexOf(email)).replaceWith(newRow(email))
    }

    const userTable = Bulma.table({
        classList: ["is-fullwidth"],
        body: access.map(email => newRow(email))
    })

    const element = Bulma.field({},
        Bulma.label(locale.string({
            enGB: "Sharing",
            deDE: "Teilen",
            frFR: "Partage",
            svSE: "Delning",
        })),
        Bulma.field(
            {
                styles: ["has-addons"],
            },
            Bulma.control(
                {
                    styles: ["is-expanded"],
                },
                emailInput.element,
            ),
            Bulma.control({},
                Bulma.button(
                    {
                        styles: ['is-primary'],
                        onClick: onClickInvite,
                    },
                    locale.string({
                        enGB: "Invite",
                        deDE: "Einladen",
                        frFR: "Inviter",
                        svSE: "Bjud in",
                    })
                )
            ),
        ),
        userTable,
    )

    return {
        element,
        getAccess: () => [...access],
        getNotify: () => [...notify],
    }
}

/**
 * DEPRECATED
 * @param {DeviceMetadata} meta
 */
function tagsField(meta) {
    const allTags = state.getDeviceTags().filter(tag => !isReservedTag(tag))
    const deviceTags = meta.Tags?.filter(tag => !isReservedTag(tag)) || []

    /** @type {(tag: string) => HTMLDivElement} */
    const tagControl = tag => {
        const selected = deviceTags.includes(tag)

        const selectedTag = Bulma.tagWithAddon({
            content: tag,
            color: "is-primary",
        }, {
            content: MaterialDesign.icon({ id: "remove" }),
            onClick: () => {
                binarySearchRemove(deviceTags, tag)
                selectedTag.replaceWith(deselectedTag)
            },
        })

        const deselectedTag = Bulma.tagWithAddon({
            content: tag,
        }, {
            content: MaterialDesign.icon({ id: "add" }),
            onClick: () => {
                binarySearchInsert(deviceTags, tag)
                deselectedTag.replaceWith(selectedTag)
            },
        })

        return Bulma.control({}, selected ? selectedTag : deselectedTag)
    }

    const tagInput = Bulma.input({
        type: "text",
        placeholder: "New tag",
    })

    const onClickAdd = () => {
        const tag = tagInput.getValue()
        tagInput.setValue("")
        if (deviceTags.includes(tag)) return

        binarySearchInsert(allTags, tag)
        binarySearchInsert(deviceTags, tag)

        tagsField.replaceChildren(...allTags.map(tag => tagControl(tag)))
    }

    const tagsField = Bulma.field(
        {
            styles: ["is-grouped", "is-grouped-multiline"],
        },
        ...allTags.map(tag => tagControl(tag)),
    )

    const element = Bulma.field(
        {},
        Bulma.label(locale.strings.tags),
        Bulma.field(
            {
                styles: ["has-addons"],
            },
            Bulma.control(
                {
                    styles: ["is-expanded"],
                },
                tagInput.element,
            ),
            Bulma.control(
                {},
                Bulma.button(
                    {
                        styles: ['is-primary'],
                        onClick: onClickAdd,
                    },
                    locale.strings.add,
                )
            ),
        ),
        tagsField,
    )

    return {
        element,
        getValue: () => [...deviceTags],
    }
}

/**
 * DEPRECATED
 * @param {string} name 
 */
function nameField(name) {
    const nameInput = Bulma.input({
        type: "text",
        value: name,
    })

    const element = Bulma.field({},
        Bulma.label(locale.strings.name),
        Bulma.control({},
            nameInput.element,
        ),
    )

    return {
        element,
        getValue: () => nameInput.getValue(),
    }
}

/**
 * DEPRECATED
 * @param {DeviceMetadata} meta
 * @param {boolean} isOwner 
 */
function ownerField(meta, isOwner) {
    const ownerSelect = Bulma.select({
        disabled: !isOwner,
        options: meta.Access.map(
            email => Bulma.option(email, email, email === meta.OwnerEmail)
        ),
    })

    const element = Bulma.field(
        {},
        Bulma.label(locale.strings.owner),
        Bulma.control(
            {},
            ownerSelect.element,
        ),
    )

    return {
        element,
        getValue: () => ownerSelect.getValue()
    }
}

/**
 * @param {string} tag 
 * @returns {boolean}
 */
function isReservedTag(tag) {
    const productTags = ["FarmCam SIM", "FenceAlarm", "FenceAlarm2", "SmartPlug", "SmartPlug2"]
    if (productTags.includes(tag)) return true
    return /.+@.+\..+/.test(tag)
}

export {
    subscriptionField,
    sharingField,
    tagsField,
    nameField,
    ownerField,
}